export const LITE_PPT_PROJECT_MODE = 'lite-ppt'
export const LITE_PPT_MIN_PAGE_COUNT = 1
export const LITE_PPT_MAX_PAGE_COUNT = 10
